import React from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSectionGallery.css';

function HeroSectionGallery() {
  return (
    <div className='hero-container-gallery'>
      
      <div className='hero-btns'>
        {/* <Button
          className='btns'
          buttonStyle='btn--outline'
          buttonSize='btn--large'
        >
          CLICK HERE TO SCHEDULE AN APPOINTMENT
        </Button> */}
      </div>
    </div>
  );
}

export default HeroSectionGallery;